import type { CSSProperties } from 'react'
import { useState, useEffect, useMemo } from 'react'

type Props = {
  seconds: number,
  format?: (h: number, m: number, s: number) => string,
  targetCount?: number,
  onCountChange?: Function,
  onCountDone?: Function,
  revert?: boolean,
  extraFont?: string,
  addonFont?: string,
  className?: string,
  style?: CSSProperties
}

const CountTime = (props: Props) => {
  const [count, setCount] = useState<number>(0)

  useEffect(() => {
    props.onCountChange?.(count)
  }, [count])

  useEffect(() => {
    let { seconds, targetCount = 0, revert } = props
    if (!seconds) {
      setCount(0)
      return
    }

    // 立即执行一次
    setCount(seconds)

    const timer = setInterval(() => {
      setCount(revert ? ++seconds : --seconds)
      if (seconds === targetCount) {
        clearInterval(timer)
        props.onCountDone?.()
      }
    }, 1000)

    return () => clearInterval(timer)

  }, [props.seconds, props.targetCount, props.revert])

  const nowTime = useMemo(() => {
    const hours = Math.floor(count / 3600)
    const minutes = Math.floor((count - hours * 3600) / 60)
    const seconds = count - hours * 3600 - minutes * 60
    return props.format?.(hours, minutes, seconds) || `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
  }, [props.format, count])

  return <span className={props.className} style={props.style}>{`${props.extraFont ?? ''}${nowTime}${props.addonFont ?? ''}`}</span>
}

export default CountTime